module.exports = __webpack_public_path__ + "img/70_M12_salute_superstorms.f8a7ba07.jpg";